// Rounded-pill status badge - green "Active" / red "Inactive", text only.
const StatusBadge = ({ status }) => {
  const isActive = Number(status) === 1;

  return (
    <span
      className="d-inline-flex align-items-center justify-content-center"
      style={{
        backgroundColor: isActive ? "#219653" : "#b83227",
        color: "#fff",
        fontSize: "11px",
        fontWeight: 600,
        padding: "4px 14px",
        borderRadius: "999px",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

const getColumns = (handleEditPtMaster, handleDelete) => [
  {
    label: "State",
    field: "stateName",
    className: "fw-semibold",
    sortable: true,
    // Checks row.zone?.name and row.zoneName too - the field was renamed
    // state -> stateName here but the API/list data may still come back
    // under the older zone/zoneName keys, so this covers both.
    render: (row) => row.zone?.name || row.stateName || row.zoneName || "N/A"
  },
  {
    label: "Salary From",
    field: "salary_from",
    sortable: true,
    render: (row) => row.salary_from ? Number(row.salary_from).toFixed(2) : "0.00"
  },
  {
    label: "Salary To",
    field: "salary_to",
    sortable: true,
    render: (row) => row.salary_to ? Number(row.salary_to).toFixed(2) : "0.00"
  },
  {
    label: "PT Amount",
    field: "pt_amount",
    className: "fw-semibold",
    sortable: true,
    render: (row) => row.pt_amount !== null && row.pt_amount !== undefined ? Number(row.pt_amount).toFixed(2) : "0.00"
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => <StatusBadge status={row.status} />
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div
          className="cursor-pointer text-primary"
          onClick={() => handleEditPtMaster(row)}
          title="Edit"
        >
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div
          className="cursor-pointer text-danger"
          onClick={() => handleDelete(row.id)}
          title="Delete"
        >
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;